import Gerritory from './Gerritory';
import OutOfTheMist from './OutOfTheMist';
import RollingRocker_EagleSimulator from './RollingRocker_EagleSimulator';
import HeeXHoo from './HeeXHoo';
import Boomeranger from './Boomeranger';
import TwoDPlatformerHunter from './2DPlatformerHunter';
import SryNoJumpForYou from './SryNoJumpForYou';
import RhythmInvaders from './RhythmInvaders';
import NSShaft from './NS-Shaft-Console';

const works = [
    {
        "type": "long-term",
        "title": "Gerritory",
        "img": "./img/work/gerritory-preview.png",
        "gif": "./img/work/gerritory-preview.gif",
        "date": "2017.11 - 2020.10",
        "job": "Designer, Programmer, Artist",
        "team": "4",
        
        "linksInfo": Gerritory.linksInfo,
        "mediaTable": Gerritory.medias,
        "description": {
            "type": "file",
            "src": Gerritory.description
        },
        "information": {
            "type": "file",
            "src": Gerritory.information
        }
    },

    {
        "type": "long-term",
        "title": "Out Of the Mist",
        "img": "./img/work/ootm-preview.png",
        "gif": "./img/work/ootm-preview.gif",
        "date": "2020.1 - present",
        "job": "Programmer",
        "team": "5",

        "linksInfo": OutOfTheMist.linksInfo,
        "mediaTable": OutOfTheMist.medias,
        "description": {
            "type": "file",
            "src": OutOfTheMist.description
        },
        "information": {
            "type": "file",
            "src": OutOfTheMist.information
        }
    },

    {
        "type": "experimental",
        "title": "Sry, No Jump For You",
        "img": "./img/work/sry-nojumpforyou-preview.png",
        "gif": "./img/work/sry-nojumpforyou-preview.gif",
        "date": "2019.11 - 2020.2",
        "job": "Designer, Programmer, Artist",
        "team": "1",

        "linksInfo": SryNoJumpForYou.linksInfo,
        "mediaTable": SryNoJumpForYou.medias,
        "description": {
            "type": "file",
            "src": SryNoJumpForYou.description 
        },
        "information": {
            "type": "file",
            "src": SryNoJumpForYou.information
        }
    },

    {
        "type": "experimental",
        "title": "Rolling Rocker & Eagle Simulator",
        "img": "./img/work/es-rr-preview.png",
        "gif": "./img/work/es-rr-preview.gif",
        "date": "2017.3 - 2017.4",
        "job": "Designer, Programmer",
        "team": "1", 

        "linksInfo": RollingRocker_EagleSimulator.linksInfo,
        "mediaTable": RollingRocker_EagleSimulator.medias,
        "description": {
            "type": "file",
            "src": RollingRocker_EagleSimulator.description
        },
        "information": {
            "type": "file",
            "src": RollingRocker_EagleSimulator.information
        }
    },

    {
        "type": "experimental",
        "title": "NS-Shaft console",
        "img": "./img/work/nsshaft-preview_0.png",
        "gif": "./img/work/nsshaft-preview.gif",
        "date": "2019.10",
        "job": "Designer, Programmer",
        "team": "1",

        "linksInfo": NSShaft.linksInfo,
        "mediaTable": NSShaft.medias,
        "description": {
            "type": "file",
            "src": NSShaft.description
        },
        "information": {
            "type": "file",
            "src": NSShaft.information
        }
    },

    {
        "ignore": true,
        "type": "experimental",
        "title": "Hee X Hoo",
        "img": "./img/work/hee-hoo-preview.png",
        "gif": "./img/work/hee-hoo-preview.gif",
        "date": "global game jam 2018",
        "job": "Level Designer, Programmer",
        "team": "5",

        "linksInfo": HeeXHoo.linksInfo,
        "mediaTable": HeeXHoo.medias,
        "description": {
            "type": "file",
            "src": HeeXHoo.description
        },
        "information": {
            "type": "file",
            "src": HeeXHoo.information
        }
    },

    {
        "ignore": true,
        "type": "experimental",
        "title": "Rhythm Invaders",
        "img": "./img/work/rhythm-invaders-preview.png",
        "gif": "./img/work/rhythm-invaders-preview.gif",
        "date": "2019.11",
        "job": "Designer, Programmer",
        "team": "1",

        "linksInfo": RhythmInvaders.linksInfo,
        "mediaTable": RhythmInvaders.medias,
        "description": {
            "type": "file",
            "src": RhythmInvaders.description 
        },
        "information": {
            "type": "file",
            "src": RhythmInvaders.information
        }
    },

    {
        "ignore": true,
        "type": "experimental",
        "title": "Boomeranger",
        "img": "./img/work/boomeranger-preview.png",
        "gif": "./img/work/boomeranger-preview.gif",
        "date": "2016.3 - 2016.6",
        "job": "Designer, Programmer",
        "team": "3",

        "mediaTable": Boomeranger.medias,
        "description": {
            "type": "file",
            "src": Boomeranger.description 
        },
        "information": {
            "type": "file",
            "src": Boomeranger.information
        }
    },

    {
        "ignore": true,
        "type": "experimental",
        "title": "Nothing Lasts Forever",
        "img": "./img/work/nothing-last-forever-preview.png",
        "gif": "./img/work/nothing-last-forever-preview.gif",
        "date": "global game jam 2016",
        "job": "Programmer",
        "team": "5",

        "mediaTable": [],
        "description": {
            "type": "file",
            "src": ""
        },
        "information": {
            "type": "file",
            "src": ""
        }
    },

    {
        "type": "long-term",
        "title": "2D Platformer Hunter (Unity Plugin)",
        "img": "./img/work/platformer-preview.png",
        "gif": "./img/work/platformer-preview.gif",
        "date": "2018.10 - present",
        "job": "Programmer",
        "team": "1",

        "linksInfo": TwoDPlatformerHunter.linksInfo,
        "mediaTable": TwoDPlatformerHunter.medias,
        "description": {
            "type": "file",
            "src": TwoDPlatformerHunter.description
        },
        "information": {
            "type": "file",
            "src": TwoDPlatformerHunter.information
        }
    }
];

export default works;